export class ImagePath {
    public static imagePath = ['star_package.png', 'super_package.png', 'mega_package.png', 'ultimate_package.png', 'ultimate_package.png'];
}
